import { createStyles, rem } from "@mantine/core"

export const useStyles = createStyles((theme, { hasError }: { hasError: boolean }) => ({
    counter: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "flex-end",
        gap: rem(2),
        width: "100%",
        position: "absolute",
        bottom: hasError ? 0 : "-1rem",
        color: hasError ? theme.colors.red[9] : theme.colors.gray[5],
        fontSize: rem(12),
        lineHeight: rem(12),
    },
    letterAmount: {
        color: hasError ? theme.colors.red[9] : theme.colors.gray[6],
    },
    wrapper: {
        position: "relative",
        width: "100%",
    },
}))
